import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { DailyPluckingAverageAnalaysisReportSchema } from "../DailyPluckingAverageAnalaysisReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import CreatePdf from './createPdf';
import ReactToPrint from "react-to-print";
import { saveAs } from 'file-saver';
import '../../../Common/Table/table.css';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import _, { forEach } from 'lodash';
import moment from "moment";
import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const screenCode = 'DAILYPLUCKINGAVERAGEANALYSIS';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

export function DailyPluckingAverageAnalaysisReport(props) {
    const classes = useStyles();
    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "",
        operationEntityID: "",
        collectionPointID: "",
        month: "",
        employeeTypeID: "0"
    });

    const [customSearch, setCustomSearch] = useState({
        regNumber: ''
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        operationEntity: "",
        collectionPoint: ""
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(DailyPluckingAverageAnalaysisReportSchema).options({ allowUnknown: true });
    const contentRowNames = [
        { range: 12, colName: "<=12kgs" }, { range: 13, colName: "13kgs" },
        { range: 14, colName: "14kgs" }, { range: 15, colName: "15kgs" },
        { range: 16, colName: "16kgs" }, { range: 17, colName: "17kgs" },
        { range: 18, colName: "18kgs" }, { range: 19, colName: "19kgs" },
        { range: 20, colName: "20kgs" }, { range: 24, colName: "21-24kgs" },
        { range: 25, colName: ">=25kgs" }
    ];

    const [data, setdata] = useState([]);
    const [total, setTotal] = useState([]);
    const [data1, setdata1] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [searchButtonHide, setSearchButtonHide] = useState(false);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
        resetDropDowns(DropdownChanges.group);
    }, [searchData.groupID])

    useEffect(() => {
        getCollectionPointsForDropDown();
        resetDropDowns(DropdownChanges.operationEntity);
    }, [searchData.operationEntityID])

    useEffect(() => {
        handleSearch1(customSearch.regNumber);
    }, [customSearch.regNumber]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'DAILYPLUCKINGAVERAGEANALYSIS');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    function resetDropDowns(type) {
        if (type === DropdownChanges.operationEntity) {
            setsearchData({
                ...searchData,
                collectionPointID: "0",
            });
        } else if (type === DropdownChanges.group) {
            setsearchData({
                ...searchData,
                operationEntityID: "0",
                collectionPointID: "0",
            });
        }
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;
        const error = { ...errors };
        const errorMessage = validateProperty(target, DailyPluckingAverageAnalaysisReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
        clearTableRelatedData();
    }

    function getNumDaysInMonth(dateStr) {
        const [year, month] = dateStr.split('-');
        const date = new Date(year, month + 1, 0);
        return date.getDate();
    }

    async function handleSearch(e) {
        e.preventDefault();
        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages)
            return;
        const result = await service.getReportData(searchData);
        formatResult(result);
        getSelectedDropdownValuesForReport(searchData);
    }

    function getDayName(date, year, month) {
        const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const dayOfWeek = new Date(`${year}-${month}-${date}`).getDay();
        return dayNames[dayOfWeek];
    }

    function formatResult(data) {
        const numDaysInMonth = getNumDaysInMonth(searchData.month);
        let dateArray = [];
        for (let i = 1; i <= numDaysInMonth; i++) {
            if (i < 10) {
                dateArray.push('0' + i);
            }
            else { dateArray.push(i); }
        }
        const notAvailableDates = dateArray.filter(
            (date) =>
                !data.some(
                    (item) => Number(date) === Number(item.cardReadTime.slice(8, 10))
                )
        );

        let newData = [];
        newData = [...data];
        newData.forEach(x => {
            x.type = 1
        })
        notAvailableDates.forEach(x => {
            newData.push({
                cardReadTime: searchData.month + '-' + x + 'T00:00:00',
                list: [{
                    "collectionPointID": 0,
                    "cardReadTime": searchData.month + '-' + x + 'T00:00:00',
                    "employeeID": 0,
                    "totalAmount": 0
                }],
                type: 0
            })
        })

        newData.forEach(x => {
            const dateObj = moment(x.cardReadTime);
            const date = dateObj.date();
            const month = dateObj.month() + 1;
            const year = dateObj.year();
            const dayName = getDayName(date, year, month);

            x.date = x.cardReadTime.slice(8, 10);
            x.dayName = dayName;

            x.list.forEach(y => {
                if (y.totalAmount > 0 && y.totalAmount <= 12) {
                    y.range = 12;
                    y.date = y.cardReadTime.slice(8, 10);
                } else if (y.totalAmount == 13) {
                    y.range = 13;
                    y.date = y.cardReadTime.slice(8, 10);
                } else if (y.totalAmount == 14) {
                    y.range = 14;
                    y.date = y.cardReadTime.slice(8, 10);
                } else if (y.totalAmount == 15) {
                    y.range = 15;
                    y.date = y.cardReadTime.slice(8, 10);
                } else if (y.totalAmount == 16) {
                    y.range = 16;
                    y.date = y.cardReadTime.slice(8, 10);
                } else if (y.totalAmount == 17) {
                    y.range = 17;
                    y.date = y.cardReadTime.slice(8, 10);
                } else if (y.totalAmount == 18) {
                    y.range = 18;
                    y.date = y.cardReadTime.slice(8, 10);
                } else if (y.totalAmount == 19) {
                    y.range = 19;
                    y.date = y.cardReadTime.slice(8, 10);
                } else if (y.totalAmount == 20) {
                    y.range = 20;
                    y.date = y.cardReadTime.slice(8, 10);
                } else if (y.totalAmount >= 21 && y.totalAmount < 25) {
                    y.range = 24;
                    y.date = y.cardReadTime.slice(8, 10);
                } else if (y.totalAmount > 25) {
                    y.range = 25;
                    y.date = y.cardReadTime.slice(8, 10);
                } else {
                    y.range = 0;
                    y.date = y.cardReadTime.slice(8, 10);
                }
            })
        });
        newData.sort((a, b) => (a.date) - (b.date));

        const tableDataWithTotals = newData.map(item => {
            const totals = contentRowNames.reduce((acc, x) => {
                if (x.range !== 0) {
                    const res = item.list.filter(y => y.range === x.range)
                    if (res.length > 0) {
                        acc.count += res.length
                        acc.percent += (res.length / item.list.filter(y => y.dayName === item.dayName).length) * 100
                    }
                    acc.rowTotal += acc.percent;
                }
                return acc;
            }, { count: 0, percent: 0, rowTotal: 0 })

            return {
                ...item,
                totals
            }
        })
        const ress = tableDataWithTotals.flatMap(item => item.list).filter(y => y.range > 0)

        setTotal(ress)
        setTableData(tableDataWithTotals);
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            operationEntity: operationEntity[searchForm.operationEntityID],
            collectionPoint: collectionPoint[searchForm.collectionPointID],
            month: searchForm.month,
            employeeTypeID: searchForm.employeeTypeID
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function onCancelClick() {
        setsearchData({
            ...searchData,
            collectionPointID: "0",
        });

        clearTableRelatedData();
    }

    function clearTableRelatedData() {
        setdata([]);
        setIsTableHide(true);
        setSelectedSearchValues([]);
    }

    async function handleSearch1(data2) {
        if (data == null || data.length == 0) {
            setdata(data1)
        }
        const Default = data.filter(x => x.registrationNumber.toLowerCase().includes(data2.toLowerCase()) || x.firstName.toLowerCase().includes(data2.toLowerCase()))
        if (data2 == '') {
            setdata(data1)
            return;
        }
        setdata(Default)
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Daily Plucking Average Analaysis Report"
                                isButtonEnable={false}
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Collection point *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection point--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-4 pb-1">
                                    <InputLabel shrink id="employeeTypeID">Plucking Type *</InputLabel>
                                    <Select
                                        id="employeeTypeID"
                                        select
                                        fullWidth
                                        name="employeeTypeID"
                                        onChange={(e) => handleChange(e)}
                                        value={searchData.employeeTypeID}>
                                        <MenuItem value="0">--All Plucking Type--</MenuItem>
                                        <MenuItem value="GENERAL">General</MenuItem>
                                        <MenuItem value="RSM">RSM</MenuItem>
                                        <MenuItem value="CASH">Cash</MenuItem>
                                    </Select>
                                </div>
                                <div className="col-md-4 pb-1">
                                    <InputLabel shrink id="searchDate">Month *</InputLabel>
                                    <TextField
                                        id="month"
                                        name="month"
                                        type="month"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["month"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["month"]}</FormHelperText>}
                                </div>

                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        disabled={validate(schema, searchData)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                        hidden={searchButtonHide}
                                    />
                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </div>
                        </form>
                        {tableData.length != 0 ?
                            <Container>
                                <Card style={{ justifycontent: 'center' }}>
                                    <Paper className={classes.paper}>
                                        <TableContainer>
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow style={{ border: "2px solid black" }}>
                                                        <TableCell align="center" rowSpan={2} colSpan={2} style={{ border: "2px solid black", fontWeight: "bold" }}>Day</TableCell>
                                                        {contentRowNames.map(x => {
                                                            return (
                                                                <TableCell key={x.range} colSpan={2} align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{x.colName}</TableCell>
                                                            )
                                                        })}
                                                        <TableCell colSpan={2} align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Total</TableCell>
                                                    </TableRow>
                                                    <TableRow style={{ border: "2px solid black" }}>
                                                        {contentRowNames.map(x => {
                                                            return (
                                                                <>
                                                                    <TableCell key={x.range} align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Names</TableCell>
                                                                    <TableCell key={x.range} align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>%</TableCell>
                                                                </>
                                                            )
                                                        })}
                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Names</TableCell>
                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>%</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableData.map(item => {
                                                        const ress = item.list.filter(y => y.range > 0)
                                                        let allTotal = 0;
                                                        return (
                                                            <TableRow style={{ border: "2px solid black" }} key={item.date}>
                                                                {item.dayName == "Sun" ?
                                                                    <>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold", backgroundColor: '#e77575' }}>{item.date}</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold", backgroundColor: '#e77575' }}>{item.dayName}</TableCell>
                                                                    </> :
                                                                    item.dayName == "Sat" ?
                                                                        <>
                                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold", backgroundColor: '#71cece' }}>{item.date}</TableCell>
                                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold", backgroundColor: '#71cece' }}>{item.dayName}</TableCell>
                                                                        </> :
                                                                        <>
                                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.date}</TableCell>
                                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.dayName}</TableCell>
                                                                        </>
                                                                }
                                                                {contentRowNames.map(x => {
                                                                    if (x.range != 0) {
                                                                        const res = item.list.filter(y => y.range == x.range);
                                                                        allTotal = allTotal + ((res.length / ress.length) * 100);
                                                                        return (
                                                                            <>
                                                                                {res.length > 0 ?
                                                                                    <>
                                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.range}>{res == undefined ? "-" : res.length}</TableCell>
                                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.range}>
                                                                                            {res == undefined ? "-" : (ress.length == 0 || res.length == 0 ? '0' :
                                                                                                parseFloat((res.length / parseInt(ress.length)) * 100).toFixed(2))}
                                                                                        </TableCell>
                                                                                    </> : <>
                                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.range}>{"-"}</TableCell>
                                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.range}>{"-"}</TableCell>
                                                                                    </>
                                                                                }
                                                                            </>)
                                                                    } else {
                                                                        return (
                                                                            <>
                                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.range}>{"-"}</TableCell>
                                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.range}>{"-"}</TableCell>
                                                                            </>
                                                                        )
                                                                    }

                                                                })}
                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.type == 1 ? ress.length : "-"}</TableCell>
                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.type == 1 ? (allTotal == undefined ? '-' : parseFloat(allTotal).toFixed(2)) : "-"}</TableCell>
                                                            </TableRow >
                                                        )
                                                    })}
                                                    <TableRow style={{ border: "2px solid black" }}>
                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} colSpan={2}>Total</TableCell>
                                                        {contentRowNames.map(x => {
                                                            if (x.range != 0) {
                                                                const res = tableData.flatMap(item => item.list).filter(y => y.range == x.range);

                                                                return (
                                                                    <>
                                                                        {res.length > 0 ?
                                                                            <>
                                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{res == undefined ? "-" : res.length}</TableCell>
                                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{res == undefined ? "-" : (total.length == 0 || res.length == 0 ? '0%' : parseFloat((res.length / total.length) * 100).toFixed(2))}</TableCell>
                                                                            </> : <>
                                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{"-"}</TableCell>
                                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{"-"}</TableCell>
                                                                            </>
                                                                        }
                                                                    </>
                                                                )
                                                            } else {
                                                                return (
                                                                    <>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{"-"}</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{"-"}</TableCell>
                                                                    </>
                                                                )
                                                            }
                                                        })}
                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{total.length}</TableCell>
                                                        {tableData.flatMap(item => item.list).length > 0 ?
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{'100.00'}</TableCell> :
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>-</TableCell>
                                                        }
                                                    </TableRow >
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Card>
                            </Container>
                            : null}
                    </div>
                    {tableData.length > 0 ?
                        <div className="pt-2" style={{ paddingRight: "8%" }}>
                            <ReactToPrint
                                documentTitle={"Daily Plucking Average Analaysis Report"}
                                trigger={() => <input
                                    type="button"
                                    className="btn btn-primary pull-right ml-2"
                                    value="PDF"
                                />}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePdf ref={componentRef} searchData={selectedSearchValues} contentRowNames={contentRowNames} data={tableData} total={total} />
                            </div>
                        </div>
                        : null}
                </div>
            </div>
        </Fragment >
    );
}